import { useState } from "react";
import { ChevronRight } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";
import type { ListGroupProps } from "./types";
import { springs } from "../motion";

export function ListGroup({
  title,
  icon,
  count,
  defaultOpen = true,
  children,
}: ListGroupProps) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div>
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className="flex w-full items-center gap-2 px-3 py-2 text-sm font-medium text-primary rounded-lg hover:bg-card-hover transition-colors"
      >
        <ChevronRight
          className={`h-4 w-4 text-secondary transition-transform duration-200 ${open ? "rotate-90" : "rotate-0"}`}
        />
        {icon && (
          <span className="flex items-center text-secondary">{icon}</span>
        )}
        <span>{title}</span>
        {count != null && <span className="text-secondary">({count})</span>}
      </button>

      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={springs.snappy}
            style={{ overflow: "hidden" }}
          >
            <div className="flex flex-col gap-1">{children}</div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
